/* global attachEvent */
// *******************************************************************************
// File upload
// *******************************************************************************
// Ref - https://jsfiddle.net/alexjamesbrown/2nzL9f7g/

let nextFileID = 1;
// const dataTransfer = new DataTransfer();
const filesToUpload = [];
const fileUploadInput = document.querySelectorAll('.upload-box__input');
const uploadBox = document.getElementById('upload');

const fileRemoved = new Event('fileRemoved');

const fileUploader = (evt, files) => {
  const parentElem = evt.target.closest('.upload-box');
  const selectedList = parentElem.querySelector('.upload-box__list-text-wrapper');
  const selectedListParent = parentElem.querySelector('.upload-box__list');

  Array.from(files).forEach((file) => {

    const newFile = {
      id: nextFileID,
      file
    };

    filesToUpload.push(newFile);
    nextFileID += 1;
  });

  const fileName = filesToUpload
    .map(
      (file) =>
        `<li><i class="icon : icon-document"></i> <span class='upload-box__list-text'>${file.file.name}</span><button id=${file.id} type='button' class='upload-box__list-remove'> <i class="icon : icon-close"></i> </button></li>`,
    )
    .join('');

  selectedListParent.classList.remove('hide');
  selectedList.innerHTML = `<ul>${fileName}</ul>`;
};

fileUploadInput.forEach((el) => {
  el.addEventListener('change', (evt) => {
    fileUploader(evt, evt.target.files);
  });
});

// *******************************************************************************
// Remove uploaded files
// *******************************************************************************

attachEvent('.upload-box__list-remove', 'click', (el) => {
  const removeParentElem = el.target.closest('li');

  Array.from(filesToUpload).forEach((file, i) => {
    if (file.id === Number(el.target.id)) {
      filesToUpload.splice(i, 1);
      uploadBox.value= null;
    }
  });

  uploadBox.dispatchEvent(fileRemoved);
  removeParentElem.remove();
});

// *******************************************************************************
// File drop
// *******************************************************************************

const holder = document.querySelector('.upload-box__inner');

if (holder) {
  holder.ondragover = () => false;
  holder.ondragend = () => false;
  holder.ondrop = (e) => {
    document.getElementById('file').files = e.dataTransfer.files;
    fileUploader(e, e.dataTransfer.files);
    e.preventDefault();
  };
}
